<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">I AM NOT THEIR JUDGE. I AM THEIR JUDGMENT. I AM THEIR EXECUTIONER.</p>
<p class="ded4">—M<span class="smallcaps">ACK</span> B<span class="smallcaps">OLAN</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?a19d500a